import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0773e49b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu" }
const _hoisted_2 = { class: "menu-tree-box menu-box" }
const _hoisted_3 = { class: "children" }
const _hoisted_4 = { class: "menu-tree-box system-box" }
const _hoisted_5 = { class: "children" }
const _hoisted_6 = { class: "form-btn-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_menu_node = _resolveComponent("menu-node")!
  const _component_tran_reduce = _resolveComponent("tran-reduce")!
  const _component_sc_tree = _resolveComponent("sc-tree")!
  const _component_system_node = _resolveComponent("system-node")!
  const _component_sc_btn = _resolveComponent("sc-btn")!
  const _component_sc_page = _resolveComponent("sc-page")!

  return (_openBlock(), _createBlock(_component_sc_page, {
    title: "菜单设置",
    desc: "设置菜单相关属性，勾选进行展示"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_sc_tree, { ref: "menu" }, {
            default: _withCtx(({ node, children }) => [
              _createVNode(_component_menu_node, {
                node: node,
                onAdd: ($event: any) => (_ctx.add(node)),
                onData: ($event: any) => (Object.assign(node.data, $event)),
                onMove: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onDrag(...$event)))
              }, null, 8, ["node", "onAdd", "onData"]),
              _createVNode(_component_tran_reduce, {
                show: node.opened
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(children, (child, index) => {
                      return (_openBlock(), _createBlock(_resolveDynamicComponent(child), { key: index }))
                    }), 128))
                  ])
                ]),
                _: 2
              }, 1032, ["show"])
            ]),
            _: 1
          }, 512)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_sc_tree, { ref: "system" }, {
            default: _withCtx(({ node, children }) => [
              (node.level !== 0)
                ? (_openBlock(), _createBlock(_component_system_node, {
                    key: 0,
                    node: node,
                    onAdd: _ctx.addToRoot
                  }, null, 8, ["node", "onAdd"]))
                : _createCommentVNode("", true),
              _createVNode(_component_tran_reduce, {
                show: node.opened || node.level === 0
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(children, (child, index) => {
                      return (_openBlock(), _createBlock(_resolveDynamicComponent(child), { key: index }))
                    }), 128))
                  ])
                ]),
                _: 2
              }, 1032, ["show"])
            ]),
            _: 1
          }, 512)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_sc_btn, {
          type: "primary",
          handler: _ctx.submit,
          text: "保存"
        }, null, 8, ["handler"]),
        _createVNode(_component_sc_btn, {
          style: {"margin-left":"10px"},
          handler: _ctx.reset,
          text: "重置"
        }, null, 8, ["handler"])
      ])
    ]),
    _: 1
  }))
}